<template>
  <router-view></router-view>
</template>
<style lang="scss">
#app {
  color: var(--color-text-primary);
  min-height: 100vh;
}
</style>
